import { supabase } from '@/integrations/supabase/client';

export interface WikiImageItem {
  title: string;
  description?: string;
  thumbUrl: string;
  fullUrl: string;
  width?: number;
  height?: number;
  author?: string;
}

export const wikiImagesService = async (query: string, limit: number = 60): Promise<WikiImageItem[]> => {
  try {
    const { data, error } = await supabase.functions.invoke('runAgent', {
      body: { agent: 'wiki-images', query, limit }
    });

    if (error) {
      throw new Error(error.message);
    }

    return data;
  } catch (error: any) {
    console.error('Wiki Images service error:', error);
    throw new Error(`Failed to search images: ${error.message}`);
  }
};

export const formatWikiImagesResponse = (
  items: WikiImageItem[],
  query: string,
  _isDarkMode: boolean = false
): string => {
  const images = (items || []).map(i => ({ url: i.fullUrl || i.thumbUrl })).filter(x => x.url);
  const payload = { __wiki_images: true, images, query };
  return JSON.stringify(payload);
};
